<template>
    <div class="widget-overlay">
        Loading...
    </div>
</template>

<script>

    import Vue from 'vue';

    export default Vue.extend({
        //
    });

</script>
